<template>
  <div class="new-workload-to-existing-opp">
    <div class="workload-header">
      <formUserOppregLandingForm
        v-if="oppregStep==='verification'"
        :type="'existing'"
        @continue="onLandingFormContinue"
      />
      <formUserOppregForm
        v-if="oppregStep==='oppform'"
        @continue ="onQuestionnaire" />
    </div>
    <div class="workload-actions">
      <v-layout
        v-if="oppregStep === 'listing' || oppregStep === 'workload'"
        row
        wrap
        align-center
        class="mx-3">
        <v-flex
          sm6
          md6
          xl6>
          <v-btn
            v-if="oppregStep === 'listing'"
            @click="onCreateNewWorkload">Create New Workload</v-btn>
          <v-btn
            v-if="oppregStep === 'listing'"
            :disabled="checkWorkloadToSubmit"
            class="ml-2"
            @click="onSubmitWorkloads">Submit Workloads ({{ selected.length }})</v-btn>
          <p
            v-if="selected.length && checkWorkloadToSubmit"
            class="subtitle-1 mb-0 required"><span class="subtitle-1 mb-0">ERROR: {{ showError }}</span></p>
          <v-btn
            v-if="oppregStep === 'workload'"
            @click="goBackToList">Go Back to List</v-btn>
        </v-flex>
        <v-flex
          v-if="oppregStep === 'listing'"
          class="workload-filter-row">
          <v-checkbox
            v-model="workloadStatusFilter"
            value="Submitted by User"
            color="orange"
            label="Submitted by User"
            hide-details
            class="mt-0 ml-1 workload-filter-checkbox"
          />
          <v-checkbox
            v-model="workloadStatusFilter"
            value="Incomplete"
            color="orange"
            label="Incomplete"
            hide-details
            class="mt-0 ml-1 workload-filter-checkbox"
          />
          <v-checkbox
            v-model="workloadStatusFilter"
            value="Ready for submission"
            color="orange"
            label="Ready"
            hide-details
            class="mt-0 ml-1 workload-filter-checkbox"
          />
        </v-flex>
      </v-layout>
    </div>
    <div class="workload-data">
      <!-- <div
        v-if="oppregStep==='listing'"
        class="workload-list mt-4 mx-3">
        <material-card
          color="orange"
          text="List of Workloads">
          <v-progress-linear
            v-slot:progress
            v-if="newOppRegistration.searching"
            color="orange"
            indeterminate/>
          <v-data-table
            :headers="filteredWorkloadHeaders"
            :items="filteredWorkloadList"
            :pagination.sync="pagination"
            v-model="selected"
            item-key="Registration_Id"
            select-all
            no-data-text="No workload available"
          >
            <template v-slot:items="props">
              <tr :active="props.selected" >
                <td>
                  <can
                    i="manage"
                    a="oppreg">
                    <v-checkbox
                      v-model="props.selected"
                      color="orange"
                      hide-details
                    />
                  </can>
                </td>
                <td>
                  <can
                    i="manage"
                    a="oppreg">
                    <span v-if="props.item.Workload_Status === 'Submitted by User'">{{ props.item.Registration_Id }}</span>
                    <a
                      v-else
                      href="#"
                      @click="onEditWorkload(props.item)">{{ props.item.Registration_Id }}</a>
                  </can>
                </td>
                <td>{{ props.item.OppReg_Req_Date == '0000-00-00' || props.item.OppReg_Req_Date == null ? 'None' : props.item.OppReg_Req_Date }}</td>
                <td>{{ props.item.Workload_Status }}</td>
                <td>{{ props.item.Contact_Email }}</td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </div> -->
      <formUserOppregWorkload
        v-if="oppregStep==='workload'"
        :sfdc-id="sfdcId"
        :type="newOppRegistration.type"
        :view="'user'" />
    </div>
  </div>
</template>
<script>

import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      searchId: '',
      selected: [],
      // workloadsFilter: 'All',
      Workload_Status: '',
      showError: 'Unable to submit, one or more selected workloads are still incomplete/already submitted',
      workloadStatusFilter: ['Incomplete', 'Ready for submission'],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
    }
  },
  computed: {
    ...mapState('user/requestOppreg', ['workloadHeaders', 'workloadList', 'newOppRegistration', 'sfdcId', 'registering', 'oppregStep']),
    filteredWorkloadHeaders () {
      let headersToShow = ['Registration_Id', 'OppReg_Req_Date', 'Workload_Status', 'Contact_Email']
      return this.workloadHeaders.filter(header => headersToShow.includes(header.value))
    },
    filteredWorkloadList () {
      if (this.workloadStatusFilter.length) {
        return this.workloadList.filter(workload => this.workloadStatusFilter.includes(workload.Workload_Status))
      } else {
        return this.workloadList
      }
    },
    checkWorkloadToSubmit () {
      let loadToSubmitWorkload = [
        'Incomplete',
        'Incomplete/Under Review',
        'Approved - Tier 3 12%',
        'Submitted by User',
        'Approved - Tier 1 23% - PPA',
        'Submitted to AWS',
        'Disqualified - Incomplete',
        'Disqualified – AWS forecast conflict']
      let validateSubmitWorkload = false

      if (!this.selected.length) return true

      for (var i = 0; i < this.selected.length; i++) {
        let toSubmitWorkload = loadToSubmitWorkload.includes(this.selected[i].Workload_Status)
        if (toSubmitWorkload) {
          validateSubmitWorkload = true
          break
        }
      }
      return validateSubmitWorkload
    }
  },
  mounted () {
    this.$store.commit('user/requestOppreg/resetRegistration')
    this.resetNewOppRegistration()
    if (this.$route.query.id) {
      this.$store.commit('user/requestOppreg/setSfdcId', this.$route.query.id)
      this.$store.commit('user/requestOppreg/setOppregStep', 'listing')
      this.$store.dispatch('user/requestOppreg/getWorkloadsByOppId', this.$route.query.id)
      this.searchId = this.$route.query.id
    }
  },
  methods: {
    ...mapMutations({
      clearWorkloadForm: 'user/requestOppreg/clearWorkloadForm',
      showNewWorkload: 'user/requestOppreg/showNewWorkload',
      setWorkloadData: 'user/requestOppreg/setWorkloadData',
      showEditWorkload: 'user/requestOppreg/showEditWorkload',
      // hideWorkload: 'user/requestOppreg/hideWorkload',
      resetNewOppRegistration: 'user/requestOppreg/resetNewOppRegistration',
      setValidatedRegistration: 'user/requestOppreg/setRegistrationIdValidation'
    }),
    onSearchOpportunity () {
      this.$store.dispatch('user/requestOppreg/getWorkloadsByOppId', this.searchId)
    },
    onCreateNewWorkload () {
      this.showNewWorkload(this.sfdcId)
    },
    onSubmitWorkloads () {
      console.log('submit workloads')
      this.$store.dispatch('user/requestOppreg/submitMultipleWorkload', this.selected)
    },
    onEditWorkload (workload) {
      this.setValidatedRegistration({
        loading: false,
        success: false,
        error: false,
        successMessage: '',
        validated: true
      })
      let { Contact_Email, ...workloadData } = workload
      this.setWorkloadData({ ...workloadData })
      this.showEditWorkload(this.sfdcId)
      this.$store.commit('setChangeLogRecord', {
        id: workload.Project_Id,
        changeFrom: { ...this.$store.state['user/requestOppreg'].workloadForm.fields } },
      { root: true }
      )
    },
    goBackToList () {
      this.$store.commit('user/requestOppreg/setOppregStep', 'listing')
    },
    onLandingFormContinue () {
      // this.$store.commit('user/requestOppreg/setOppregStep', 'listing')
      this.$store.dispatch('user/requestOppreg/getWorkloadsByOppId', this.sfdcId)
      console.log('continue saving...')
    },
    onQuestionnaire() {
      this.$store.commit('user/requestOppreg/setOppregStep', 'workload')
      // this.$store.dispatch('user/requestOppreg/getWorkloadsByOppId', this.sfdcId)
      // console.log('continue saving...')
    }
  }
}
</script>

<style lang="scss" scoped>
.new-workload-to-existing-opp {
  .header-title {
    background: #000;
    color: #fff;
    padding: 0 10px;
  }
  .search-container {
    background: #000;
  }

  .search-opp-btn {
    padding: 15px 30px;
  }

  .opp-title {
    color: #fff;
    text-align: center;
  }

  .workload-filter-row {
    text-align: right;
    padding-right: 20px;
  }

  .workload-filter-checkbox {
    display: inline-block;
  }
}
</style>
